import React from 'react';
import Skills from '../About/Skills';

const HomeAboutSkill = () => {
    
    return (
        <div className='text-light'>
            <h2 className='heading-two'>PROFESSIONAL SKILLS </h2>
            <p className='text-center pb-3'><span className='text-uppercase text-light'>my</span> <span className='text-capitalize heading-three'>Talent</span></p>
            <Skills>
                
                <b style={{
                    background: '#313552',
                    border: '1px solid #ffb400',
                    borderWidth: '0 1px 1px 0',
                    display: 'inline-block',
                    padding: '4px',
                    transform: 'translateY(33.5px) rotate(45deg) skew(3deg, 3deg) translateX(-27px)',
                    bottom: '8px',
                    position: 'absolute',
                    boxSizing: 'border-box'
                }}></b>
            </Skills>
        </div>
    );
};

export default HomeAboutSkill;